import React, { Component } from 'react';
import './modalProgress.css';
import HyperLink from './hyperlink';

export class ModalDownloadProgress extends Component {

    constructor(props) {
        super(props);
        this.autoCloseTimer = null;
    }

    componentDidUpdate(prevProps) {
        // Start auto-close timer when download URL arrives
        if (this.props.url && !prevProps.url && this.props.onClose) {
            this.autoCloseTimer = setTimeout(() => {
                this.props.onClose();
            }, 3000);
        }
    }

    componentWillUnmount() {
        if (this.autoCloseTimer) {
            clearTimeout(this.autoCloseTimer);
        }
    }

    render() {
        if (!this.props.open) return null;

        const done = this.props.url != null;

        return (
            <div className="progress-overlay">
                <div className="progress-card">
                    {done ? <div className="checkmark-circle" /> : <div className="spinner" />}
                    <div className="progress-title">{this.props.title}</div>
                    <div className="progress-label">
                        {this.props.label ? this.props.label : "Missing label."}
                    </div>
                    {done &&
                        <React.Fragment>
                            <div className="progress-download-text">
                                <HyperLink
                                    onAutostart={(downloadHyperlink) => {
                                        downloadHyperlink.click();
                                    }}
                                    prefix="Download should start automatically. If not, "
                                    link="click here"
                                    href={this.props.url}
                                    suffix=" to download manually."
                                    download={true}
                                />
                            </div>
                            <button className="progress-done-btn" onClick={this.props.onClose}>
                                Done
                            </button>
                        </React.Fragment>
                    }
                </div>
            </div>
        );
    }
}

/* istanbul ignore next */
export default ModalDownloadProgress;
